/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "../reports.module.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import { Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { withTranslation } from "react-i18next";
import { formatDate } from "../../../../helper/dateFormatter";

const PaymentReportTable = (props) => {
  const t = props.t;
  return (
    <div className={classes.root}>
      <TableContainer>
        <Table className={"newGlobalTable"} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("orderId");
                }}
              >
                <b>{t("ORDER_ID")}</b>
                {/* Sort indication */}
                {props.sortBy === "orderId" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell className="global-custom-sorting-header">
                <b>{t("CUSTOMER_NAME")}</b>
              </TableCell>
              <TableCell className="global-custom-sorting-header">
                <b>{t("OWNER")}</b>
              </TableCell>
              {props.providerType === "SALES_CHNL_PROVIDER" && (
                <TableCell
                  className="global-custom-sorting-header"
                  onClick={(e) => {
                    props.updateSorting("amount");
                  }}
                >
                  <b>{t("AMOUNT")}</b>
                  {/* Sort indication */}
                  {props.sortBy === "amount" ? (
                    <span className="material-icons">
                      {props.sortOrder === "DESC"
                        ? "expand_less"
                        : "expand_more"}
                    </span>
                  ) : (
                    <span className="material-icons sorting-indicator-icon">
                      unfold_more
                    </span>
                  )}
                </TableCell>
              )}
              <TableCell className="global-custom-sorting-header">
                <b>{t("PAID_VIA")}</b>
              </TableCell>
              {/* <TableCell className="global-custom-sorting-header">
                                    <b>Status</b>
                                </TableCell> */}
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("orderDate");
                }}
              >
                <b>{t("ORDER_DATE")}</b>
                {/* Sort indication */}
                {props.sortBy === "orderDate" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Show orders list */}
            {props.list.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.orderId}</TableCell>
                <TableCell>{row.customerName}</TableCell>
                <TableCell>{row.clientName}</TableCell>
                {props.providerType === "SALES_CHNL_PROVIDER" && (
                  <TableCell>{row.amount}</TableCell>
                )}
                <TableCell>{row.paidBy}</TableCell>
                {/* <TableCell>{row.status}</TableCell> */}
                <TableCell>{formatDate(row.orderDate)}</TableCell>
              </TableRow>
            ))}
            {/* If there is no orders to show */}
            {props.list.length === 0 && (
              <TableRow>
                <TableCell colSpan={12} align="center">
                  {t("NO_RECORDS_FOUND")}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {props.totalPaymentCount > 0 && (
        <div
          className="global-custom-pagination"
          style={{ background: "rgba(196, 196, 196, 0.2)" }}
        >
          <label style={{ float: "left", padding: "5px" }}>
            {t("TOTAL_RECORDS")}: {props.totalPaymentCount}
          </label>
          <label>
            {t("ROWS_PER_PAGE")}:
            <Select
              value={props.rowsPerPage}
              onChange={props.handleChangeRowsPerPage}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </label>
          <Pagination
            count={Math.ceil(props.totalPaymentCount / props.rowsPerPage)}
            onChange={props.handleChangePage}
            page={props.page}
            showFirstButton
            showLastButton
          />
        </div>
      )}
    </div>
  );
};

export default withTranslation("translations")(PaymentReportTable);
